export default __webpack_public_path__ + "e5d71571fc90be569ee3c6249ab703ad.riv";